import React from 'react';
import { OTA_MODE_OPTIONS, otaModeColorStyle, OtaMode } from '../utils/otaMode';

interface OtaModeSelectProps {
  value: OtaMode;
  onChange: (mode: OtaMode) => void;
  disabled?: boolean;
  id?: string;
  size?: 'sm' | 'md';
}

const OtaModeSelect: React.FC<OtaModeSelectProps> = ({
  value,
  onChange,
  disabled = false,
  id,
  size = 'sm',
}) => {
  return (
    <select
      id={id}
      className={`form-select${size === 'sm' ? ' form-select-sm' : ''}`}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value as OtaMode)}
      style={{
        width: size === 'sm' ? '7.5rem' : undefined,
        fontWeight: 600,
        ...otaModeColorStyle(value),
      }}
    >
      {OTA_MODE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default OtaModeSelect;
